import React from 'react';
import './Footer.css';
import logo from '../assets/logo.svg';

import { Instagram, Linkedin } from 'lucide-react';

const FOOTER_LINKS = {
  product: [
    { label: 'Features', href: '#features' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'Solutions', href: '#solution' },
  ],
  legal: [
    { label: 'Privacy Policy', href: '#privacy' },
    { label: 'Terms of Service', href: '#terms' },
    { label: 'Security', href: '#security' },
  ],
};

function Footer() {
  const handleLinkClick = (e, href) => {
    e.preventDefault();

    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="footer">
      <div className="footer-top container">
        <div className="footer-brand">
          <a href="#hero" onClick={e => handleLinkClick(e, '#hero')}>
            <img
              src={logo}
              alt="BOSS Logo"
              className="footer-logo"
            />
          </a>

          <p className="footer-tagline">
            All-in-one operations for service businesses. Streamline quotes, projects, invoices, and cash flow.
          </p>

          <div className="footer-contact">
            <a href="mailto:admin@kliqontech.com" className="footer-contact-link">
              admin@kliqontech.com
            </a>
          </div>

          <div className="footer-social" aria-label="Social links">
            <a
              href="https://www.linkedin.com/company/kliqon-technologies/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="social-link"
            >
              <Linkedin className="social-icon" aria-hidden="true" />
            </a>
            <a
              href="https://www.instagram.com/kliqontech?igsh=M2dzdDh6ampwc2Jo"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="social-link"
            >
              <Instagram className="social-icon" aria-hidden="true" />
            </a>
          </div>
        </div>

        <nav className="footer-links">
          <div className="link-group">
            <h4 className="link-title">Product</h4>
            <ul>
              {FOOTER_LINKS.product.map(item => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={e => handleLinkClick(e, item.href)}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </nav>
      </div>

      <div className="footer-bottom container">
        <p className="copy">© 2025 BOSS. All rights reserved.</p>
        
      </div>
    </footer>
  );
}

export default Footer;
